import { render, staticRenderFns } from "./Pendentes.vue?vue&type=template&id=3711b560&"
import script from "./Pendentes.vue?vue&type=script&lang=js&"
export * from "./Pendentes.vue?vue&type=script&lang=js&"
import style0 from "./Pendentes.vue?vue&type=style&index=0&id=3711b560&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports